export class InventoryTransferModal {
    public constructor() {
    }
    public id?: string;
    public description: string | undefined;
    public destinationStockId: string | undefined;
    public sourceStockId: string | undefined;
    public status:number=-1
    
    public details :InventoryTransferDetailModal[] = [];
}

export class InventoryTransferDetailModal {
    public constructor() {
    }
    public id?: string;
    public drugName?: string;
    public drugNameHint?: string;
    public count?: string;
    public countHint?: string;
    public expireDate?: string;
    public expireDateHint?: string;
    public inventoryDetailId?: string;
}